import { ACKNOWLEDGED_SPOTLIGHT_ITEMS_KEY } from '../cacheConstants';
import { getItem, setItem } from 'owa-local-storage';
import SpotlightItem from '../store/schema/SpotlightItem';

interface CachedSpotlightItem {
    itemId?: string;
    conversationId?: string;
    rowKey?: string;
}

export const getAcknowledgedSpotlightItemsCache = (): CachedSpotlightItem[] => {
    const spotlightItemsValue = getItem(window, ACKNOWLEDGED_SPOTLIGHT_ITEMS_KEY);
    return spotlightItemsValue ? JSON.parse(spotlightItemsValue) : [];
};

export const updateAcknowledgedSpotlightItemsCache = (spotlightItems: CachedSpotlightItem[]) => {
    setItem(window, ACKNOWLEDGED_SPOTLIGHT_ITEMS_KEY, JSON.stringify(spotlightItems));
};

/**
 * Checks to see if Spotlight item is arleady tracked in localStorage cache of
 * items that user has interacted with.
 */
export const isItemInAcknowledgedSpotlightItemsCache = (params: {
    itemId?: string;
    conversationId?: string;
    rowKey?: string;
    acknowledgedSpotlightItems?: CachedSpotlightItem[];
}): boolean => {
    const {
        itemId,
        conversationId,
        rowKey,
        acknowledgedSpotlightItems = getAcknowledgedSpotlightItemsCache(),
    } = params;

    for (const item of acknowledgedSpotlightItems) {
        if (
            (itemId && item.itemId === itemId) ||
            (conversationId && item.conversationId === conversationId) ||
            (rowKey && item.rowKey === rowKey)
        ) {
            return true;
        }
    }

    return false;
};

/**
 * Cleans up cache of acknowledged Spotlight items by removing any items in the
 * cache that are no longer considered Spotlight items.
 */
export const cleanAcknowledgedSpotlightItemsCache = (spotlightItems: SpotlightItem[]) => {
    const acknowledgedSpotlightItems = getAcknowledgedSpotlightItemsCache();
    const cleanedAcknowledgedSpotlightItems = [];

    for (const acknowledgedSpotlightItem of acknowledgedSpotlightItems) {
        const {
            itemId: acknowledgedItemId,
            conversationId: acknowledgedConversationId,
            rowKey: acknowledgedRowKey,
        } = acknowledgedSpotlightItem;

        for (const spotlightItem of spotlightItems) {
            const { itemId, conversationId, rowKey } = spotlightItem;

            if (
                (acknowledgedItemId && acknowledgedItemId === itemId) ||
                (acknowledgedConversationId && acknowledgedConversationId === conversationId) ||
                (acknowledgedRowKey && acknowledgedRowKey === rowKey)
            ) {
                cleanedAcknowledgedSpotlightItems.push(acknowledgedSpotlightItem);
                break;
            }
        }
    }

    updateAcknowledgedSpotlightItemsCache(cleanedAcknowledgedSpotlightItems);
};
